import * as moment from "moment";
import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import classNames from "classnames";
import { ILogEntry } from "motw_core/Entity/ILogEntry";

export function LogMonumentalSteps({ data }: { data: ILogEntry[] }) {
    return (
        <div style={{ margin: `30px` }}>
            <ProgressBar
                filledBackground="linear-gradient(to right, rgb(75, 80, 30), rgb(221 128 50))"
                percent={100}
            >
                {GetSteps(data)}
            </ProgressBar>
        </div>
    );
}

const stepStyleClass = StyleClass(`steppedProgressBar_Step`, {
    color: "white",
    width: "20px",
    height: "20px",
    fontSize: "12px",
    backgroundColor: "#ffb100",
    boxShadow: "0px 0px 10px gold",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

function GetSteps(data: ILogEntry[]) {
    const lookBackDays = 365;

    const formattedData = data.map((row) => ({
        entry: row.entry,
        date: moment(row.lastmodifiedtime).format("YYYY-MM-DD"),
    }));

    // Note: using lookBackDays - 1 here to prevent warning showing up
    // with react-step-progress-bar
    const stepKeys = [...Array(lookBackDays - 1).keys()];

    const result = stepKeys.map((rowIndex) => {
        const daysAgo = lookBackDays - rowIndex;
        const date = moment().subtract(daysAgo, "days").format("YYYY-MM-DD");

        const rowsOnDate = formattedData.filter((row) => row.date === date);
        const logEntryText = rowsOnDate.map((row) => row.entry).join(`, `);
        const hasAccomplishment = rowsOnDate.length > 0;

        const tooltip = `${date} - ${logEntryText}`;

        return (
            <Step key={rowIndex}>
                {() => (
                    <div
                        className={classNames({
                            [stepStyleClass]: hasAccomplishment,
                        })}
                        data-tip={tooltip}
                    />
                )}
            </Step>
        );
    });

    return result;
}
